import React from "react";

export const QRCodeDisplay = ({ qrCode, onRefresh }) => {
  if (!qrCode) {
    return (
      <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
        <p className="text-gray-500 mb-4">QR Code não disponível</p>
        {onRefresh && (
          <button
            onClick={onRefresh}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            🔄 Gerar QR Code
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md">
      <h3 className="text-lg font-semibold mb-4">Escaneie com seu WhatsApp</h3>

      <div className="mb-4">
        <img
          src={qrCode}
          alt="QR Code WhatsApp"
          className="w-64 h-64 border-4 border-gray-200 rounded-lg"
        />
      </div>

      <div className="text-center space-y-2">
        <p className="text-sm text-gray-600">
          1. Abra o WhatsApp no seu telefone
        </p>
        <p className="text-sm text-gray-600">
          2. Toque em <strong>Mais opções</strong> ou{" "}
          <strong>Configurações</strong>
        </p>
        <p className="text-sm text-gray-600">
          3. Selecione <strong>Aparelhos conectados</strong>
        </p>
        <p className="text-sm text-gray-600">
          4. Toque em <strong>Conectar um aparelho</strong>
        </p>
        <p className="text-sm text-gray-600">5. Escaneie este código QR</p>
      </div>

      {onRefresh && (
        <button
          onClick={onRefresh}
          className="mt-4 px-4 py-2 text-sm text-blue-600 hover:text-blue-800"
        >
          🔄 Atualizar QR Code
        </button>
      )}
    </div>
  );
};
